import foxone from "./foxone";
import mixin from "./mixin";

export default {
  foxone,
  mixin
};
